import React, { useEffect, useState } from 'react';
import './modalSortDirections.scss';
import { useSelector } from 'react-redux';
import { favoritesInformation, favoritesSlice } from '../../../../../redux/slices/favoritesSlice';
import FavoriteSortItem from './FavoriteSortItem';
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { useTranslate } from '../../../../context/languageContext';
import { useSetModalChild, useSetModalOpened } from '../../../../context/modalContext';
import {
  useEditSortFavoriteDirectionsMutation,
  useLazyGetFavoritesQuery
} from '../../../../../redux/login/favorite/FavoriteServiceApi';
import { useDispatch } from 'react-redux';
import { eventsModalstoggleVisibilitySlice } from '../../../../../redux/slices/eventsModalstoggleVisibilitySlice';

export default function ModalSortDirections() {
  const favDirections = useSelector(favoritesInformation).directions;
  const t = useTranslate();
  const setModalOpen = useSetModalOpened();
  const setModalContent = useSetModalChild();
  const [editSortFavoriteDirections] = useEditSortFavoriteDirectionsMutation();
  const [getFavorites] = useLazyGetFavoritesQuery();
  const dispatch = useDispatch();
  const [itemObjects, setItemObjects] = useState(favDirections);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  useEffect(() => {
    return () => setModalContent(null);
  }, []);

  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event;

    if (active.id !== over?.id) {
      setItemObjects((itemObjects) => {
        if (active?.id && over?.id) {
          const oldIndex = itemObjects.findIndex((elem: any) => elem?.id === (active?.id as never));
          const newIndex = itemObjects.findIndex((elem: any) => elem?.id === (over?.id as never));
          if (oldIndex !== -1 && newIndex !== -1) {
            return arrayMove(itemObjects, oldIndex, newIndex);
          }
        }
        return itemObjects;
      });
    }
  }

  async function saveChangesDirections() {
    const mappedDirections = itemObjects.map((favDirSorted: any, index: number) => ({
      addressId: favDirSorted?.id,
      addressOrder: index
    }));
    await editSortFavoriteDirections(mappedDirections).then(async (res: any) => {
      await getFavorites().then((result: any) => {
        if (!result?.error) {
          dispatch(favoritesSlice.actions.updateFavorites(result.data));
          dispatch(
            eventsModalstoggleVisibilitySlice.actions.toggleVisibilityCustomizedSnackbarModalWidget(
              {
                showModal: true,
                background: '#00763D',
                text: t('save_success')
              }
            )
          );
          setModalContent(null);
          setModalOpen(false);
        } else {
          dispatch(
            eventsModalstoggleVisibilitySlice.actions.toggleVisibilityCustomizedSnackbarModalWidget(
              {
                showModal: true,
                background: '#A31610',
                text: t('serviceError'),
                status: 'error'
              }
            )
          );
        }
      });
    });
  }

  return (
    <div className="modalSort">
      <div className="headerSort">
        <div className="title sortTitle">
          {t('modal_sort_directions_title')}
        </div>
      </div>
      <div className='modalContentSort'>          
        <div className='sortDesc'>{t('favorites_sort_description')}</div>
        <DndContext
          autoScroll={true}
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}>
          <SortableContext items={itemObjects} strategy={verticalListSortingStrategy}>
            {itemObjects?.map((favDir: any) => (
              <FavoriteSortItem key={favDir?.id} direction={favDir} typeId={1} />
            ))}
          </SortableContext>
        </DndContext>
      </div>

      <div className="row bottomButtons">
        <button
          className="btn-secondary"
          onClick={() => {
            setModalContent(null);
            setModalOpen(false);
          }}>
          {t('cancel')}
        </button>
        <button className="btn-primary" onClick={() => saveChangesDirections()}>
          {t('save')}
        </button>
      </div>
    </div>
  );
}
